import { jsx as _jsx } from "react/jsx-runtime";
import UIStatusDot from 'UIComponents/tag/UIStatusDot';
export const getSubscriptionStatusAvatar = value => {
  switch (value) {
    case 'active':
      return /*#__PURE__*/_jsx(UIStatusDot, {
        use: "active",
        "data-test-id": "subscription-status-active"
      });

    case 'past_due':
      return /*#__PURE__*/_jsx(UIStatusDot, {
        use: "warning",
        "data-test-id": "subscription-status-warning"
      });

    case 'unpaid':
      return /*#__PURE__*/_jsx(UIStatusDot, {
        use: "danger",
        "data-test-id": "subscription-status-unpaid"
      });

    case 'canceled':
    case 'expired':
      return /*#__PURE__*/_jsx(UIStatusDot, {
        use: "default",
        "data-test-id": "subscription-status-canceled-expired"
      });

    case 'scheduled':
      return /*#__PURE__*/_jsx(UIStatusDot, {
        use: "thunderdome",
        "data-test-id": "subscription-status-scheduled"
      });

    default:
      return undefined;
  }
};